export default function () {
    return (
        <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_2359_28110)">
                <path
                    d="M6.64062 23.9849V29.6197C6.64062 29.9104 6.87611 30.1454 7.16632 30.1454H29.8493C30.14 30.1454 30.375 29.9104 30.375 29.6197V27.8512C30.375 27.5609 30.14 27.3255 29.8493 27.3255H11.5367C11.2465 27.3255 11.0109 27.0899 11.0109 26.7997V23.5112"
                    stroke="black"
                    strokeWidth="1.35"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M9.38281 30.146V31.5802" stroke="black" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M27.7188 30.146V31.5802" stroke="black" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M23.9989 12.8403C26.0476 15.5831 25.9593 19.4776 23.5946 22.1341C21.0485 24.9952 16.7717 25.401 13.7461 23.1788"
                    stroke="black"
                    strokeWidth="1.35"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.16128 18.3521C8.64663 15.6304 9.46728 12.7105 11.606 10.6397C14.9869 7.36703 20.3803 7.45424 23.6529 10.8352L20.8145 13.6752C19.1128 12.1801 16.5404 12.2363 14.8843 13.8397C13.1421 15.5263 12.8414 18.2212 14.5279 19.964L9.49203 25.0015C8.99889 25.4947 8.20083 25.4983 7.70404 25.0105L6.00539 23.3423C5.5028 22.8487 5.49754 22.0406 5.99382 21.5406L9.16128 18.3521Z"
                    stroke="black"
                    strokeWidth="1.35"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M22.5046 9.84262L25.4471 6.90014C25.6527 6.69456 25.6527 6.36177 25.4471 6.15621L24.4445 5.15417C24.2394 4.94861 23.9067 4.94861 23.7011 5.15417L20.1914 8.66397"
                    stroke="black"
                    strokeWidth="1.35"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.1777 16.0518C18.8839 16.0518 19.456 16.624 19.4561 17.3301C19.4561 18.0361 18.8839 18.6084 18.1777 18.6084C17.4716 18.6084 16.8994 18.0361 16.8994 17.3301C16.8994 16.624 17.4716 16.0518 18.1777 16.0518Z"
                    stroke="black"
                    strokeWidth="1.35"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_2359_28110">
                    <rect width="36" height="36" fill="white" transform="translate(0 0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
}
